/**
 * `npm start` always uses the local ASP-Admin API unless you opt into a remote host.
 * Set REACT_APP_USE_REMOTE_API=1 in `.env.local` to use REACT_APP_API_URL (staging/UAT).
 * Production builds run via `scripts/build-with-env.cjs` so `.env.production` wins over `.env.local`.
 */
export function resolveApiBaseUrl(): string {
  const configured = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  const useRemote = process.env.REACT_APP_USE_REMOTE_API === '1';
  if (process.env.NODE_ENV === 'development' && !useRemote) {
    return 'http://localhost:5200/AspAdminAPI';
  }
  return configured;
}

export const API_BASE_URL = resolveApiBaseUrl();
